export const KEY_DETENTEUR_ASSO_MORALE = 'detenteur-asso-morale';
export const KEY_DETENTEUR_METIER_MORALE = 'detenteur-metier-morale';
export const KEY_DETENTEUR_METIER_PHYSIQUE = 'detenteur-metier-physique';
export const KEY_DETENTEUR_COLLECTIONNEUR_PHYSIQUE = 'detenteur-collectionneur-physique';
export const KEY_DETENTEUR_COLLECTIONNEUR_MORALE = 'detenteur-collectionneur-morale';

export const CHOIX_STATUT_METIER_ASSO = [
    {
        libelle: 'Détenteur association - Personne morale',
        value: KEY_DETENTEUR_ASSO_MORALE,
        disabled: false,
    },
    {
        libelle: 'Détenteur métier - Personne morale',
        value: KEY_DETENTEUR_METIER_MORALE,
        disabled: false,
    },
    {
        libelle: 'Détenteur métier - Personne physique',
        value: KEY_DETENTEUR_METIER_PHYSIQUE,
        disabled: false,
    },
    {
        libelle: 'Collectionneur - personne physique',
        value: KEY_DETENTEUR_COLLECTIONNEUR_PHYSIQUE,
        disabled: false,
    },
    {
        libelle: 'Collectionneur - personne morale',
        value: KEY_DETENTEUR_COLLECTIONNEUR_MORALE,
        disabled: false,
    },
];
